import { Link } from 'react-router-dom'
import { Home, LineChart } from 'lucide-react'
import { Shell } from '../components/Layout'
import { fa } from '../lib/format'
import { useSeo } from '../lib/seo'

export default function NotFound() {
  // صفحه ۴۰۴ نباید ایندکس شود، وگرنه گوگل ده‌ها نشانی بی‌ارزش را نگه می‌دارد
  useSeo({ title: 'صفحه پیدا نشد', noindex: true }, [])
  return (
    <Shell>
      <div className="relative flex min-h-[60vh] flex-col items-center justify-center overflow-hidden text-center">
        <div className="pointer-events-none absolute h-72 w-72 rounded-full bg-brand-500/20 blur-[100px]" />
        <div className="num relative bg-gradient-to-l from-brand-400 to-aqua bg-clip-text text-8xl font-black text-transparent">
          {fa('۴۰۴')}
        </div>
        <h1 className="relative mt-4 text-xl font-bold text-white">صفحه مورد نظر پیدا نشد</h1>
        <p className="relative mt-2 max-w-sm text-sm leading-7 text-slate-400">
          ممکن است آدرس را اشتباه وارد کرده باشید یا این صفحه حذف شده باشد.
        </p>
        <div className="relative mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-primary"><Home className="h-4 w-4" /> بازگشت به خانه</Link>
          <Link to="/markets" className="btn-ghost"><LineChart className="h-4 w-4" /> مشاهده بازارها</Link>
        </div>
      </div>
    </Shell>
  )
}
